<template>
  <div
    class="tw-bg-[#F6C46A] tw-shadow tw-rounded tw-p-4 tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-center tw-gap-4"
  >
    <div class="tw-flex tw-items-center tw-gap-4">
      <i class="airalo-icon-warning tw-text-[40px]" />
      <span
        class="tw-text-[14px]/[20px] tw-font-semibold tw-flex tw-items-center tw-whitespace-pre-line"
        v-text="message"
      />
    </div>

    <template v-if="actionText">
      <button
        type="button"
        :class="[
          'tw-w-full md:tw-max-w-[167.5px]',
          'tw-flex tw-justify-center tw-items-center',
          'tw-bg-transparent tw-text-primary tw-text-10 tw-font-bold tw-tracking-widest',
          'tw-border tw-border-solid tw-border-primary',
          'tw-rounded',
          'tw-py-2 tw-px-2.5',
          'tw-transition tw-duration-300 tw-ease-in-out',
          'hover:tw-bg-primary hover:tw-text-white',
        ]"
        @click="$emit('click')"
      >
        {{ actionText }}
      </button>
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      message: {
        type: String,
        required: true,
      },
      actionText: {
        type: String,
        required: false,
      },
    },
  }
</script>
